export default function SampleCard(props) {
    return <>
        <div class="card MMP-sample-image mx-auto shadow-lg my-2 border-secondary" style={{"width" : "90%"}}>
            <img src={props.image} class="card-img-top" alt={props.title} />
            <div class="card-body">
                <p class="card-text small text-muted">{props.title}</p>
            </div>
        </div>
    </>
}